import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "@fetch/axios";
import { TokenContext } from "@context/TokenContext";
import { useTranslation } from "@hooks/useTranslation";

const AgregarEditarDireccionEnvio = () => {
  const MySwal = withReactContent(Swal)
  const { idDireccion } = useParams();
  const [id, setId] = useState(idDireccion ? idDireccion : null);
  const [street1, setStreet1] = useState(null);
  const [street2, setStreet2] = useState(null);
  const [cp, setCp] = useState(null);
  const [city, setCity] = useState(null);
  const [country, setCountry] = useState(null);
  const [detail, setDetail] = useState(null);
  const { getToken,getVerified } = useContext(TokenContext);
  const { translate } = useTranslation();
  const [countries,setCountries]=useState(JSON.parse(localStorage.getItem('countries_arteonu')));
  const API_KEY = localStorage.getItem('gg');
  const [cityOptions, setCityOptions] = useState([]); // Nuevo estado para las opciones de ciudad

  const navigate = useNavigate();


  const handlePostalCodeChange = async (e) => {
    const value = e.target.value;
    setCp(value);

    if (value.length >= 4) {
      try {

        const response = await axios.get(
          `https://maps.googleapis.com/maps/api/geocode/json`,
          {
            params: {
              address: countries.find(c => c.id == (country ?? 142)).name + ' ' + value,
              key: API_KEY,
            },
          }
        );

        const results = response.data.results;
        if (results.length > 0) {

          const cities = results.reduce((acc, result) => {
            const addressComponents = result.address_components;
            console.log(addressComponents);

            // Filtra todos los componentes que coincidan con los tipos deseados
            const cityComponents = addressComponents.filter((component) =>
              component.types.includes("locality") ||
              component.types.includes("political") ||
              component.types.includes("postal_town")
            );

            // Agrega cada ciudad encontrada, evitando duplicados
            cityComponents.forEach((component) => {
              if (component.long_name && !acc.includes(component.long_name)) {
                acc.push(component.long_name);
              }
            });

            return acc;
          }, []);

          setCityOptions(cities);

          // Si solo hay una opción, la seleccionamos automáticamente
          if (cities.length === 1) {
            setCity(cities[0]);
          } else {
            setCity(""); // Limpiamos la ciudad si hay múltiples opciones
          }


        } else {
          setCityOptions([]);
          setCity("Sin resultados");
        }


      } catch (error) {
        console.error("Error al buscar la ciudad:", error);
        setCityOptions([]);
        setCity("Error de búsqueda");
      }
    } else {
      setCityOptions([]);
      setCity("");
    }
  };

  const guardar = async (type = 1) => {

    if (!street1) {
      MySwal.fire({
        text: translate('error.ar'),
        icon: 'error',
        title: 'Oops...'
      })
      return;
    }
    if (!cp) {
      MySwal.fire({
        text: translate('error.cp'),
        icon: 'error',
        title: 'Oops...'
      })
      return;
    }
    if (!city) {
      MySwal.fire({
        text: translate('error.city'),
        icon: 'error',
        title: 'Oops...'
      })
      return;
    }
    try {
      await axios[type == 1 ? 'post' : 'put'](
        type == 1 ? '/addresses/create' : '/addresses/update',
        {
          id: id,
          country_id: country ?? 142,
          line: street1,
          line2: street2,
          postal_code: cp,
          city: city,
          details: detail,
          verified: getVerified() ? 1 : 0,

        },
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${getToken()}`
          }
        }
      );
      MySwal.fire({
        text: translate('error.addresse'),
        icon: 'success',
      })
      navigate('/mi-perfil');
    } catch (error) {
      console.error('Error al guardar la dirección:', error);
      MySwal.fire({
        text: translate('error.addressd'),
        icon: 'error',
        title: 'Oops...'
      })
    }


  };

  const eliminar = async () => {

    try {
      await axios.delete('/addresses/remove?id=' + idDireccion, {
        headers: { 'Authorization': 'Bearer ' + getToken() }
      });

      MySwal.fire({
        text: translate('error.addresde'),
        icon: 'success',
      })
      navigate('/mi-perfil')

    } catch (error) {
      MySwal.fire({
        text: translate('error.addresmo'),
        icon: 'error',
        title: 'Oops...'
      })
      navigate('/mi-perfil')
    }

  };

  useEffect(() => {

    if (idDireccion) {

      const fetchDireccion = async () => {

        const user = JSON.parse(localStorage.getItem('user_arteonu'));
        try {
          const res = await axios.get('/addresses/detail?id=' + idDireccion, {
            headers: { 'Authorization': 'Bearer ' + getToken() }
          });
          const dir = res.data;
          if (dir.email == user.email) {
            setId(dir.id)
            setStreet1(dir.line)
            setStreet2(dir.line2)
            setCp(dir.postal_code)
            setDetail(dir.details)
            setCity(dir.city)
            setCountry(dir.country_id)
          } else {

            MySwal.fire({
              text: translate('error.addressnoa'),
              icon: 'error',
              title: 'Oops...'
            })
            navigate('/mi-perfil')
          }
        } catch (error) {

          MySwal.fire({
            text: translate('error.addressnoa'),
            icon: 'error',
            title: 'Oops...'
          })
          navigate('/mi-perfil')
        }
      };

      fetchDireccion();
    }

    const getCountries = async ()=>{

      if (!localStorage.getItem('countries_arteonu')) {
        try {
          const response = await axios.get(`/countries?lang=${localStorage.getItem('lang_arteonu')}`);
          localStorage.setItem('countries_arteonu', JSON.stringify(response.data));
          setCountries(response.data)
        } catch (error) {
          console.error('Error fetching countries:', error);
        }
      }
    }
    getCountries()
  }, [])

  return (
    <>
      <div className="PerfilContent pt-tophead">

        <div className={`CategoryTitle PerfilSection`}>
          <ul className="Breadcrumb">
            <li onClick={() => { navigate('/home') }} style={{ cursor: "pointer" }}>Home</li>
            <li onClick={() => { navigate('/mi-perfil') }} style={{ cursor: "pointer" }}>{translate('view.myprofile.my_profile')}</li>
            <li>{idDireccion ? translate('view.address.edit') : translate('view.address.add')} {translate('view.address.address')}</li>
          </ul>
        </div>

        <div className="grid-title" style={{ display: 'block' }}>

          <h2>{idDireccion ? translate('view.address.edit_shipping') : translate('view.address.add_shipping')}</h2>

        </div>

        <hr />

        <section className="DireccionEnvio">

          <div className="form-box">

            <label className="FormData">

              <em className="RequiredData">{translate('view.address.street_numer_apt_1')}</em>

              <div className="FormInputLight">
                <input placeholder={translate('view.address.street_numer_apt_1')} onChange={(e) => { setStreet1(e.target.value) }} value={street1} />
              </div>

            </label>

            <label className="FormData">

              <em className="RequiredData">{translate('view.address.street_numer_apt_2')}</em>

              <div className="FormInputLight">
                <input placeholder={translate('view.address.street_numer_apt_2')} onChange={(e) => { setStreet2(e.target.value) }} value={street2} />
              </div>

            </label>

            <label className="FormData">
              <em className="RequiredData">{translate('login.country')}</em>
              <div className="FormInputLight">
                <select onChange={(e) => {
                  const selectedCountryId = parseInt(e.target.value, 10); // Parse to integer
                  const selectedCountry = countries.find(country => country.id == selectedCountryId);
                  if (selectedCountry) {
                    setCountry(selectedCountry.id); // Assuming you still want to set the country ID
                  }
                }}>
                  {countries &&
                    countries.map((pais) => (
                      <option key={pais.id} value={pais.id}
                        selected={(!country && pais.id === 142) || country == pais.id}
                      >
                        {pais.name}
                      </option>
                    ))}
                </select>
                <i className="InputIcon icon-Select"></i>
              </div>
            </label>


            <div className="form-row">

              <label className="FormData">
                <em className="RequiredData">{translate('view.address.postal_code')}</em>
                <div className="FormInputLight">
                  <input placeholder={translate('view.address.postal_code')} onChange={handlePostalCodeChange} value={cp} />
                </div>
              </label>


              <label className="FormData">
                <em className="RequiredData">{translate('view.address.city')}</em>
                <div className="FormInputLight">
                  <input
                    placeholder={translate('view.address.city')}
                    onChange={(e) => { setCity(e.target.value) }}
                    value={city}
                    list="cityOptions"
                  />
                  <datalist id="cityOptions">
                    {cityOptions.map((option, index) => (
                      <option key={index} value={option} />
                    ))}
                  </datalist>
                </div>
              </label>

            </div>


            <label className="FormData">
              <em className="RequiredData">{translate('view.address.detail')}</em>
              <div className="FormInputLight">
                <textarea placeholder={translate('view.address.adddetail')} onChange={(e) => { setDetail(e.target.value) }} value={detail}></textarea>
              </div>
            </label>

            <button className="ButtonLightMedium" onClick={() => { guardar(idDireccion ? 2 : 1) }}>
              {idDireccion ? translate('view.address.update') : translate('view.address.store')}
            </button>

            {idDireccion && <button className="DeleteAddressButton ButtonDark" style={{ cursor: 'pointer' }} onClick={() => { eliminar() }}>{translate('view.address.delete')}</button>}


          </div>

        </section>

      </div>
    </>
  );

};

export default AgregarEditarDireccionEnvio;
